<template>
  <div class="cmp-accounting-reports dt-tabs-container">
    <v-tabs
      v-model="activeTabIndex"
      color="transparent"
      light
      class="dt-tab dt-page--tab"
    >
      <v-tab
        @click="tabSelected"
        ripple
        :value="activeTabIndex"
        to="./invoice"
        v-if="invoiceReportPermission"
        >{{ $t("invoice") }} {{ $t("report") }}</v-tab
      >
      <v-tab
        @click="tabSelected"
        ripple
        :value="activeTabIndex"
        to="./booking"
        v-if="bookingReportPermission"
        >{{ $t("booking") }} {{ $t("report") }}</v-tab
      >
    </v-tabs>
    <router-view></router-view>
  </div>
</template>


<script>
import * as ActionTypes from "../../store/types";
import { mapKeyToAction } from "../../../../store/global";
import { AccountingStoreNamespace as storeNS } from "../../store";
import InvoiceReports from "./invoice-reports";
import BookingReports from "./booking-reports";
import { mapGetters } from "vuex";
import { checkTabPermission } from "@/router/guard/";

const moduleRoute = "accounting";
const submenuRoute = "reports";

export default {
  components: {
    InvoiceReports,
    BookingReports,
  },
  mounted: function () {
    this.fetchData();
  },
  data: function () {
    return {
      activeTabIndex: "0",
    };
  },
  computed: {
    ...mapGetters(storeNS, {
      reportData: "reportData",
    }),
    invoiceReportPermission: function () {
      return checkTabPermission(moduleRoute, submenuRoute, "invoice");
    },
    bookingReportPermission: function () {
      return checkTabPermission(moduleRoute, submenuRoute, "booking");
    },
  },
  methods: {
    ...mapKeyToAction(storeNS, [
      ActionTypes.ReportData.FETCH.ALL,
      ActionTypes.ReportData.UPDATE.ALL,
    ]),
    fetchData: function () {
      this[ActionTypes.ReportData.FETCH.ALL]();
    },
    tabSelected: function () {
      this.reportData.invoice_projects = this.reportData.invoice_projects.map(
        (p) => {
          p.selected = false;
          return p;
        }
      );
      this.reportData.artistlist = this.reportData.artistlist.map((p) => {
        p.selected = false;
        return p;
      });
      this[ActionTypes.ReportData.UPDATE.ALL]({ reportData: this.reportData });
    },

    //MARK: Methods
  },
};
</script>

<style  lang="scss">
.cmp-accounting-reports {
  &.dt-tabs-container {
    background: none;
  }
  // .tabs__wrapper {
  //   margin-top: -15px;
  // }
  .tabs__container {
    background: none !important;
   // border-bottom: 1px solid hsla(0, 0%, 78.4%, 0.5) !important;
    // .tabs__item--active {
    //   color: var(--text-primary) !important;
    //   border-bottom: 4px solid var(--bc-accent);
    //   background: #e8f2ff !important;
    //   color: var(--bc-accent) !important;
    // }
  }
  // .tabs__container .tabs__div .tabs__item {
  //   border-radius: 0 !important;
  //   margin-bottom: -3px !important;
  // }
}
</style>